$(document).ready(function() {
	var $slidersection = $('.slider-section');
	var $sliderlink = $('.links .link', $slidersection);

	$sliderlink.on('click', function() {
		$sliderlink.removeClass('active');
		$(this).addClass('active');
		
		var linkIndex = $(this).index();
		$('.slider-content .slide', $slidersection).removeClass('active');
		
		var slide = $('.slider-content .slide:eq(' + linkIndex + ')', $slidersection);		
		slide.addClass('active');
	});
});